import { render, staticRenderFns } from "./CategoryShowPage.vue?vue&type=template&id=75a5056c"
import script from "./CategoryShowPage.vue?vue&type=script&lang=js"
export * from "./CategoryShowPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports